import React, { useState } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const [dark, setDark] = useState(true);
  const navigate = useNavigate();

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen flex flex-col justify-center items-center bg-white dark:bg-[#0e1015] text-black dark:text-white font-vazir px-6">
        <h1 className="text-6xl font-extrabold mb-4">۴۰۴</h1>
        <p className="text-lg text-center mb-6">متاسفیم، صفحه‌ای که به دنبال آن بودید پیدا نشد.</p>

        <button
          onClick={() => navigate('/')}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-xl"
        >
          بازگشت به صفحه اول
        </button>
      </div>

      {/* کلید تغییر تم */}
      <button
        onClick={() => setDark(!dark)}
        className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg flex items-center justify-center"
      >
        {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
      </button>
    </div>
  );
}
